import {atom} from 'jotai';

// Current registry project (ProjectDTO) and selected language sub-project, synced from route context
export const projectAtom = atom(null);
export const subProjectAtom = atom(null);

// Topics list + selection
export const topicsAtom = atom([]);
export const selectedTopicAtom = atom(null);
export const topicsLoadingAtom = atom(false);

// Filters on the topic list panel
export const topicSearchAtom = atom('');
export const topicLanguageFilterAtom = atom(''); // '' = all languages

// Documents of the selected topic
export const documentsAtom = atom([]);
export const documentsLoadingAtom = atom(false);

// Query history of the selected topic - fetched once (in TopicDetailsPanel) and shared with QueryTab
// and the details header's "Avg response" tile, so switching tabs doesn't re-fetch it.
export const queriesAtom = atom([]);

// Which tab of the details panel is open: documents | query | graph | settings
export const detailTabAtom = atom('documents');

export const errorAtom = atom(null);
